<div class="label-container">
  <div class="header-container">
    <img src="../../../../assets/ibc-label-logo.png" alt="ibc-logo" />
    <div class="ibc-address">
      <div *ngFor="let ibcAddress of ibcHeaderAddress">
        <span class="ibc-heading-h5-bold">{{ ibcAddress.companyName }}</span>
        <span class="ibc-heading-h7-subtitle-bold">{{
          ibcAddress.addressLineOne
        }}</span>
        <span class="ibc-heading-h7-subtitle-bold"
          >{{ ibcAddress.city }} {{ ibcAddress.state }}
          {{ ibcAddress.postalCode }} {{ ibcAddress.countryCode }}</span
        >
        <span class="ibc-heading-h7-subtitle-bold"
          >{{ ibcAddress.phone }} | {{ ibcAddress.website }}</span
        >
      </div>
    </div>
  </div>
  <div class="shipper-info-container" *ngFor="let item of shipperInfo">
    <div>
      <div>
        <span>{{ item['shipperName'] }} - {{ item['companyName'] }}</span>
        <span>{{ item['addressLine1'] }}, {{ item['addressLine2'] }}</span>
        <span
          >{{ item['city'] }}, {{ item['state'] }}
          {{ item['postalCode'] }}</span
        >
        <span>{{ item['countryCode'] }} - {{ item['phoneNumber'] }}</span>
      </div>
      <div>
        <div class="label-key-value-container">
          <span>Acct:</span>
          <span>{{ item['account'] }}</span>
        </div>
        <div class="label-key-value-container">
          <span>Ref#:</span>
          <span>{{ item['referenceNumber'] }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="consignee-info-container" *ngFor="let item of consigneeInfo">
    <div>
      <span class="ibc-heading-h6-bold"
        >{{ item['consigneeName'] }} - {{ item['companyName'] }}</span
      >
      <span class="ibc-heading-h6-semi-bold"
        >{{ item['addressLine1'] }}, {{ item['addressLine2'] }}</span
      >
      <span class="ibc-heading-h6-semi-bold"
        >{{ item['city'] }}, {{ item['state'] }} {{ item['postalCode'] }}</span
      >
      <div class="country-and-country-code-container">
        <span class="ibc-heading-h6-semi-bold">{{ item['country'] }}</span> -
        <span class="ibc-heading-h6-bold">{{ item['countryCode'] }}</span>
      </div>
      <span class="ibc-heading-h6-semi-bold">{{ item['phone'] }}</span>
    </div>
  </div>
  <div class="shipment-info-container">
    <div>
      <div>
        <div
          *ngFor="let item of shipmentInfo | keyvalue"
          class="shipment-info-row-container">
          <span class="ibc-body-text-medium-bold"
            >{{ renderShipmentKeyValues(item.key) }} :</span
          >
          <span class="ibc-body-text-medium-bold">{{ item.value }}</span>
        </div>
      </div>
      <qr-code
        value="{{ qrData }}"
        size="170"
        errorCorrectionLevel="M"
        styleClass="qr-container" />
    </div>
  </div>
  <div class="bar-code-container">
    <ngx-barcode6
      [bc-format]="'CODE128'"
      [bc-value]="shipmentExt"
      [bc-display-value]="true"
      [bc-width]="1.8"
      [bc-height]="50">
    </ngx-barcode6>
  </div>
</div>

<div class="print-actions-container">
  <button
    class="ibc-medium-button ibc-secondary-default-button cursor infoPage-preview-cancel-btn {{
      isShipmentLabelPrinted ? 'hide-btn' : 'show-btn'
    }}"
    (click)="closePreviewWindow()">
    <span class="ibc-body-text-regular">
      {{ popupButtons.Cancel }}
    </span>
  </button>
  <button
    class="ibc-medium-button ibc-primary-default-button cursor infoPage-preview-print-btn {{
      isShipmentLabelPrinted ? 'hide-btn' : 'show-btn'
    }}"
    (click)="print()">
    <span class="">
      {{ popupButtons.Print }}
    </span>
  </button>
</div>
